const throttleHaveParam = {
  inserted: function(el, binding) {
    let timeout;
    el.addEventListener("input", function() {
      const _this = this;
      const args = arguments;
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          const valueFn = binding.value.fn;
          const data = binding.value.data;
          // 注意在这里是可以传输出数据的
          // 利用 promise 执行回调参数  例如页面上传返回的http 地址 也可以执行dome操作全局设置半透明蒙层
          valueFn.apply(_this, [...args, data]);
        }, 2000);
      }
    });
  },
};
export default throttleHaveParam;
